import getServerSidePropsPage from 'root/src/client/util/getServerSidePropsPage'
import ClearRouteComponent from 'root/src/client/web/ClearRouteComponent'

const SignIn = ClearRouteComponent

export const getServerSideProps = getServerSidePropsPage

export default SignIn
